<template>
  <div class="menu-footermenu-container">
    <ul id="menu-footermenu" class="menu">
      <router-link
        v-for="route in myRoutes" 
        :key="route.ID"  tag="li" 
        :to="{ path: shortPath(route.url, route.target), params: { id: route.object_id } }" 
        class="nav-link"
        active-class="active"
        >
        <a >{{ route.title }}</a>
      </router-link>
    </ul>
  </div>

</template>
<script>

  export default {
    name: 'FooterMenu',
    data: () => {
      return {
        myRoutes: {},
      }
    },
    mounted () {
      this.getMenu();
    },
    computed: {
    },
    methods: {
      shortPath:function (path, target){
        // if targetpath is has different URL than this
        let parser = document.createElement('a');
        parser.href = path;

        parser.protocol; // => "http:"
        parser.hostname; // => "example.com"
        parser.port;     // => "3000"
        parser.pathname; // => "/pathname/"
        parser.search;   // => "?search=test"
        parser.hash;     // => "#hash"
        parser.host;     // => "example.com:3000"
        //console.log(parser.host);
        if (parser.host!==this.globalHost) {
          let op='';
          if (target=="_blank") {
            op=`/blank/${path}`;
          } else {
            op=`/external/${path}`;
          }
          return op;
        }
        let url = path;
        let pathname = new URL(url).pathname;
        return pathname;
      },

      getMenu (){
        this.$http.get(
          '/menus/v1/menus/footerMenu')
        .then( (response) => {
          //console.log(response);
          this.myRoutes = response.data.items;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

  };

</script>
